export default "/images/cmmc__audit_icon.png";